class FormTabs {
    constructor() {
        this.DOM = {
            body: document.body,
            formTabs: document.querySelectorAll('.form-tabs'),
            linksSwitchTab: document.querySelectorAll('a[href*="?tab="], a[href*="&tab="]')
        };
    }

    setEventListeners() {
        this.DOM.formTabs.forEach((formTabs) => {
            formTabs.addEventListener('click', (event) => this.switchTabByEvent(event, formTabs));
        });

        this.DOM.linksSwitchTab.forEach((el) => {
            el.addEventListener('click', (event) => this.openTabHref(event));
        });

        // Catch custom popup event
        // Example: document.dispatchEvent(new CustomEvent('switchTabByID', { detail: 'tab-example' }));
        document.addEventListener('switchTabByID', (event) => {
            const tabId = event.detail;
            console.log('switchTab custom event', tabId);
            if (tabId) {
                this.switchTab(tabId);
            }
        });
    }

    triggerTabFromUrl() {
        const url = new URL(window.location.href);
        const tabId = url.searchParams.get('tab');

        if (tabId) {
            this.switchTab(tabId);
        }
    }

    openTabHref(event) {
        event.preventDefault();
        const href = event.target.href;
        const url = new URL(href);
        const tabId = url.searchParams.get('tab');
        if (tabId) {
            this.switchTab(tabId);
        }
    }

    switchTabByEvent(event, formTabs) {
        const trigger = event.target.closest('button.form-tab');
        if (!trigger || !formTabs.contains(trigger)) {
            return;
        }

        const tabId = trigger.dataset.tabTarget;
        if (!tabId) {
            return;
        }

        this.switchTab(tabId, formTabs);
    }

    switchTab(elementID, paneParent = null) {
        const switchInsideParent = (parent) => {
            const tabElement =
                parent.querySelector(`.form-tabs-pane#${elementID}`) ??
                parent.querySelector(`.form-tabs-pane#content-${elementID}`);
            if (!tabElement) {
                return false;
            }

            const paneSiblings = parent.querySelectorAll('.form-tabs-pane');
            const tabSiblings = parent.querySelectorAll('button.form-tab');

            if (paneSiblings.length > 0) {
                paneSiblings.forEach((el) => {
                    el.classList.remove('active');
                    el.setAttribute('aria-hidden', 'true');
                });
            }

            if (tabSiblings.length > 0) {
                tabSiblings.forEach((el) => {
                    el.classList.remove('active');
                    el.setAttribute('aria-selected', 'false');
                    el.setAttribute('tabindex', '-1');
                });
            }

            tabElement.classList.add('active');
            tabElement.setAttribute('aria-hidden', 'false');

            const trigger =
                parent.querySelector(`button.form-tab[data-tab-target="${elementID}"]`) ??
                parent.querySelector(`button.form-tab[data-tab-target="content-${elementID}"]`) ??
                parent.querySelector(`button.form-tab[aria-controls="${tabElement.id}"]`);

            if (trigger) {
                trigger.classList.add('active');
                trigger.setAttribute('aria-selected', 'true');
                trigger.setAttribute('tabindex', '0');
            }

            return true;
        };

        if (paneParent) {
            switchInsideParent(paneParent);
            return;
        }

        this.DOM.formTabs.forEach((formTabs) => {
            if (switchInsideParent(formTabs)) {
                return;
            }
        });
    }

    // Keep initial ARIA state aligned with whichever tab is active on load.
    syncInitialAria() {
        this.DOM.formTabs.forEach((formTabs) => {
            const activeTab = formTabs.querySelector('button.form-tab.active');
            if (!activeTab) {
                return;
            }

            const tabId = activeTab.dataset.tabTarget;
            if (tabId) {
                this.switchTab(tabId, formTabs);
            }
        });
    }

    init() {
        this.setEventListeners();
        this.syncInitialAria();
        this.triggerTabFromUrl();
    }
}

const formTabs = new FormTabs();
if (typeof formTabs.init === 'function') {
    formTabs.init();
}
